import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { SmsListComponent } from '../../general/sms-list/sms-list.component';

@Component({
  selector: 'app-sms-account-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./sms-account-list.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class SmsAccountListComponent extends SmsListComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service, route, router);
    this.title = 'messages';
    this.subentity = 'account';
  }

  getBody() {
    const body = super.getBody();
    body.query = [
      ['account_id', '=', this.selectedAccount || this.username],
      'and',
      ['status', '=', 'S']
    ];
    return body;
  }

  async ngOnInit() {
    await super.ngOnInit();
    if (this.selectedAccount) {
      this.customActions = [];
    }
  }
}
